/**
 * Service page doctors slider (desktop picker + detail panel).
 *
 * @return {void}
 */
export function initServiceDoctors() {
	const blocks = document.querySelectorAll('[data-service-doctors]');
	const autoplayMs = 2500;

	blocks.forEach((block) => {
		const desktop = block.querySelector('[data-service-doctors-desktop]');

		if (!desktop) {
			return;
		}

		const slides = Array.from(
			desktop.querySelectorAll('[data-service-doctors-slide]')
		);
		const pickers = Array.from(
			desktop.querySelectorAll('[data-service-doctors-picker-item]')
		);
		const prevButton = desktop.querySelector('[data-service-doctors-prev]');
		const nextButton = desktop.querySelector('[data-service-doctors-next]');
		const titleEl = desktop.querySelector('[data-service-doctors-title]');
		let autoplayTimer = null;

		if (0 === slides.length) {
			return;
		}

		/**
		 * @return {void}
		 */
		const updateNavState = () => {
			const singleDoctor = slides.length <= 1;

			if (prevButton) {
				prevButton.hidden = false;
				prevButton.disabled = singleDoctor;
			}

			if (nextButton) {
				nextButton.hidden = false;
				nextButton.disabled = singleDoctor;
			}
		};

		/**
		 * @param {number} nextIndex
		 * @return {void}
		 */
		const setActiveIndex = (nextIndex) => {
			const count = slides.length;
			const index = ((nextIndex % count) + count) % count;

			slides.forEach((slide, slideIndex) => {
				slide.hidden = slideIndex !== index;
			});

			pickers.forEach((picker, pickerIndex) => {
				const isActive = pickerIndex === index;
				picker.classList.toggle('is-active', isActive);
				picker.setAttribute('aria-pressed', isActive ? 'true' : 'false');
			});

			const slide = slides[index];

			if (titleEl && slide) {
				titleEl.textContent = slide.dataset.slideTitle || '';
			}

			updateNavState();
		};

		/**
		 * @return {number}
		 */
		const getCurrentIndex = () => {
			const current = slides.findIndex((slide) => !slide.hidden);
			return current >= 0 ? current : 0;
		};

		/**
		 * @return {void}
		 */
		const stopAutoplay = () => {
			if (null !== autoplayTimer) {
				window.clearInterval(autoplayTimer);
				autoplayTimer = null;
			}
		};

		/**
		 * @return {void}
		 */
		const startAutoplay = () => {
			stopAutoplay();

			if (slides.length <= 1) {
				return;
			}

			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				return;
			}

			autoplayTimer = window.setInterval(() => {
				setActiveIndex(getCurrentIndex() + 1);
			}, autoplayMs);
		};

		/**
		 * @param {number} nextIndex
		 * @return {void}
		 */
		const goTo = (nextIndex) => {
			setActiveIndex(nextIndex);
			startAutoplay();
		};

		pickers.forEach((picker, pickerIndex) => {
			picker.addEventListener('click', () => {
				goTo(pickerIndex);
			});
		});

		prevButton?.addEventListener('click', () => {
			if (prevButton.disabled) {
				return;
			}

			goTo(getCurrentIndex() - 1);
		});

		nextButton?.addEventListener('click', () => {
			if (nextButton.disabled) {
				return;
			}

			goTo(getCurrentIndex() + 1);
		});

		setActiveIndex(0);
		startAutoplay();
	});
}
